// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_stroke1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M22 22.001L2 2.00098","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"chat-off","clipPath":"url(#clip0_543_1240)"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9.65446 3.001H8.65446L8.65346 3L9.65446 3.001ZM9.65446 3.001L21.5 3.00001L21.5 14.582M21.5 14.582V15.582L21.501 15.583L21.5 14.582ZM17 17.001H6.5L2.5 20.501L2.5 3.00098H3L17 17.001Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","mask":"props.overlapMaskUrl_stroke1"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M22 22.001L2 2.00098","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChatOffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chat-off',
    ref,
    icon: element,
  },
));

ChatOffIcon.displayName = 'ChatOffIcon';

export default ChatOffIcon;
